import React from "react";

import { createSvgIcon } from "@mui/material/utils";

export const ActiveSyncIcon = createSvgIcon(
 <svg
  width="800px"
  height="800px"
  viewBox="0 0 24 24"
  xmlns="http://www.w3.org/2000/svg"
  version="1.1">
  <g transform="translate(0 -1028.4)">
   <path
    d="m22 12a10 10 0 1 1 -20 0 10 10 0 1 1 20 0z"
    transform="matrix(-1 0 0 1 24 1028.4)"
    fill="#31cd7d"
   />
   <path
    d="m22 12a10 10 0 1 1 -20 0 10 10 0 1 1 20 0z"
    transform="matrix(-1 0 0 1 -61 1006.4)"
    fill="#31cd7d"
   />
   <path
    d="m-73 1013.4c-2.416 0-4.44 1.7-4.906 4h1.656c0.445-1.4 1.732-2.5 3.281-2.5 0.938 0 1.79 0.4 2.407 1l-1.438 1.5h2.312 1.594 0.094v-4l-1.469 1.4c-0.907-0.9-2.151-1.4-3.531-1.4zm-5 6v4l1.469-1.5c0.907 0.9 2.151 1.5 3.531 1.5 2.416 0 4.44-1.8 4.906-4h-1.656c-0.445 1.4-1.732 2.4-3.281 2.4-0.938 0-1.79-0.4-2.407-1l1.438-1.4h-2.312-1.594-0.094z"
    fill="#ecf0f1"
   />
   <path
    d="m12 6c-2.9756 0-5.4333 2.1586-5.9062 5h2.0624c0.4447-1.7243 1.9808-3 3.8438-3 1.366 0 2.537 0.7043 3.25 1.75l-1.25 1.25h1.844 2.062 0.094v-4l-1.281 1.2812c-1.095-1.3953-2.804-2.2812-4.719-2.2812zm-6 7v4l1.2812-1.281c1.095 1.395 2.8038 2.281 4.7188 2.281 2.976 0 5.433-2.159 5.906-5h-2.062c-0.445 1.724-1.981 3-3.844 3-1.366 0-2.5369-0.704-3.25-1.75l1.25-1.25h-1.8438-2.0624-0.0938z"
    transform="translate(0 1028.4)"
    fill="#ecf0f1"
   />
  </g>
 </svg>,
 "ActiveSync"
);
